<template>
  <g class="axis">
    <g class="x-axis">
      <line
        v-for="tick in xTicks"
        :key="tick"
        :x1="tick"
        :y1="0"
        :x2="tick"
        :y2="svgHeight"
        :stroke-width="1 / ratio"
        class="stroke-strong"
      />
    </g>

    <g class="y-axis">
      <line
        v-for="tick in yTicks"
        :key="tick"
        :x1="0"
        :y1="tick"
        :x2="columnCount"
        :y2="tick"
        :stroke-width="1 / ratio"
        class="stroke-strong"
      />
    </g>
  </g>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  columnCount: number
  svgHeight: number
  ratio: number
}>()

// It's a 2x2 grid
const xTicks = computed(function (): number[] {
  const ticks: number[] = []
  for (let i = 2; i <= props.columnCount; i = i + 2) {
    ticks.push(i)
  }

  return ticks
})
const yTicks = computed(function (): number[] {
  const ticks: number[] = []
  for (let i = 2; i <= props.svgHeight; i = i + 2) {
    ticks.push(i)
  }

  return ticks
})
</script>
